import React, { useState } from "react";
import { FormControlLabel, Checkbox } from "@mui/material";
import { getRuta, simpleMessage } from "../../../../helpers/Helpers";
import moment from "moment/moment";
import {
  BotonGenerar,
  FormularioSelector,
  RangoFechas,
  SelectorGestor,
  validarRangoFechas,
} from "../../../../components/reportes/selector";

const SelectorCreditsCancelled = () => {
  const [selectedGestor, setSelectedGestor] = useState("t");
  var date = new Date();
  const [fechaDesde, setFechaDesde] = useState(
    new Date(date.getFullYear(), date.getMonth(), 1)
  );
  const [fechaHasta, setFechaHasta] = useState(date);

  const [justNoReNew, setJustNoReNew] = useState(false);

  let ruta = getRuta();

  const verReport = () => {
    const errorFechas = validarRangoFechas(fechaDesde, fechaHasta);
    if (errorFechas) {
      simpleMessage(errorFechas, "error");
      return;
    }

    var params = `${selectedGestor}/${moment(fechaDesde).format(
      "YYYY-MM-DD"
    )}/${moment(fechaHasta).format("YYYY-MM-DD")}/${justNoReNew}`;
    window.open(`${ruta}/r-creditscancelled/${params}`);
  };

  return (
    <FormularioSelector>
      <SelectorGestor value={selectedGestor} onChange={setSelectedGestor} />

      <RangoFechas
        desde={fechaDesde}
        hasta={fechaHasta}
        onChangeDesde={setFechaDesde}
        onChangeHasta={setFechaHasta}
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={justNoReNew}
            onChange={() => setJustNoReNew(!justNoReNew)}
          />
        }
        label="Unicamente No Renovados"
      />

      <BotonGenerar onClick={verReport} />
    </FormularioSelector>
  );
};

export default SelectorCreditsCancelled;
